// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"ef0c7dcf","659":"58d3aeae"}[chunkId] + ".chunk.js";
};